export default "__VITE_ASSET__FE7tedoL__"